import {
  toWSMoneyString,
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSGrid,
  WSLoader,
  WSPage,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { PayoutPreferences } from "@wingspanhq/payments/dist/interfaces";
import { Route, useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useQueryPaidInvoices } from "../../query/payments/queries";
import { DownloadInvoicesCSV } from "../components/DownloadInvoicesCSV";
import { InvoicesTable } from "../components/InvoicesTable";
import { selectorIsInvoiceDeposited } from "../selectors/selectorIsInvoiceDeposited";
import { selectorIsInvoicePaidNotDeposited } from "../selectors/selectorIsInvoicePaidNotDeposited";
import { calculateInvoicesTotalMemberGross } from "../utils";
import { getPayoutMethodName, usePayoutMethods } from "../utils/payout";
import { InstantPayoutsModal } from "./InstantPayoutsModal";
import { InvoicesInvoiceDetails } from "./InvoicesInvoiceDetails";
import { InvoicesInvoiceTemplateDetails } from "./InvoicesInvoiceTemplateDetails";

export const InvoicesListPaid = () => {
  const history = useHistory();
  const invoicesQuery = useQueryPaidInvoices();
  const {
    payoutPreferences,
    payoutMethods,
    queries: {
      payoutSettingsQuery,
      accountsQuery,
      payoutSettingsDebitCardsQuery
    }
  } = usePayoutMethods();

  const invoices = invoicesQuery.data || [];
  const pendingInvoices = invoices.filter(selectorIsInvoicePaidNotDeposited);
  const depositedInvoices = invoices.filter(selectorIsInvoiceDeposited);

  const payoutMethod =
    payoutPreferences === PayoutPreferences.Standard
      ? payoutMethods.standard.active.map(getPayoutMethodName).join(" and ")
      : payoutMethods.instant.active.map(getPayoutMethodName).join(" and ");

  return (
    <>
      <Route
        path="/member/invoices/:listName/template/:invoiceTemplateId"
        component={InvoicesInvoiceTemplateDetails}
        exact
      />
      <Route
        path="/member/invoices/paid/:invoiceId/instant-deposit"
        component={InstantPayoutsModal}
        exact
      />
      <Route
        path="/member/invoices/:listName/:invoiceId"
        component={InvoicesInvoiceDetails}
        exact
      />
      <BrowserPageTitle title="Invoices" />
      <WSPage
        title="Deposits"
        breadcrumb={{
          label: "Invoicing",
          icon: "arrow-left",
          onClick: () => {
            history.push("/member/invoices");
          }
        }}
      >
        <WSElement mb="3XL">
          {payoutSettingsQuery.isLoading ||
          accountsQuery.isLoading ||
          payoutSettingsDebitCardsQuery.isLoading ? (
            <WSLoader.Spinner size="XS" />
          ) : (
            <WSText>Payments will be deposited to {payoutMethod}</WSText>
          )}
        </WSElement>

        <WSGrid>
          {pendingInvoices.length > 0 && (
            <WSGrid.Item span={{ s: "6" }}>
              <WSPanel>
                <WSFlexBox.CenterY justify="space-between" wrap="nowrap">
                  <WSAvatar.Icon
                    size="L"
                    icon="check"
                    color="green500"
                    colorBackground="gray100"
                    mr="XL"
                  />

                  <WSElement style={{ flex: 1 }}>
                    {invoicesQuery.isLoading ? (
                      <WSLoader.Spinner size="XS" />
                    ) : (
                      <>
                        <WSText.Heading5 mb="XS">
                          +
                          {toWSMoneyString(
                            calculateInvoicesTotalMemberGross(pendingInvoices)
                          )}
                        </WSText.Heading5>
                        <WSText color="gray600">pending</WSText>
                      </>
                    )}
                  </WSElement>
                </WSFlexBox.CenterY>
              </WSPanel>
            </WSGrid.Item>
          )}
        </WSGrid>

        <InvoicesTable
          title="Pending"
          actions={
            <DownloadInvoicesCSV
              invoices={pendingInvoices}
              isDataReady={invoicesQuery.status === "success"}
            />
          }
          invoices={pendingInvoices}
          my="3XL"
          listName="paid"
        />
        <InvoicesTable
          title="Deposited"
          actions={
            <DownloadInvoicesCSV
              invoices={depositedInvoices}
              isDataReady={invoicesQuery.status === "success"}
            />
          }
          invoices={depositedInvoices}
          listName="paid"
        />
      </WSPage>
    </>
  );
};
